import { useState } from 'react';
import wb from '../../../../../assets/media/wb-logo.svg';
import { MARKETS_ALL, TYPE_BUTTONS } from '../../../../../constans';
import { Row } from '../../../../../components/Basic/Blocks';
import { Input, Select } from '../../../../../components/Basic/Inputs';
import { Button } from '../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../components/Basic/Elements';

const WB_MARKETS_CONTENT_MANAGER = ['WB-1']; //;MARKETS_ALL.wb;
const WB_MARKETS_USERS = ['WB-1', 'WB-7']; //;MARKETS_ALL.wb;
const WB_MARKETS_ADMIN = MARKETS_ALL.wb; //;MARKETS_ALL.wb;

const WbContentButton = ({ roleUser = 'content', onClick = (_) => _ }) => {
  const [minPurchase, setMinPurchase] = useState(100);
  const [market, setMarket] = useState(WB_MARKETS_CONTENT_MANAGER[0]);
  const [join, setJoin] = useState({ text: 'Нет', value: false });

  let list = roleUser === 'admin' || roleUser === 'owner' ? WB_MARKETS_ADMIN : WB_MARKETS_CONTENT_MANAGER;
  list = roleUser === 'user' ? WB_MARKETS_USERS : list;

  return (
    <Row style={{ alignItems: 'flex-end' }}>
      <Input
        label={'Мин. закупка'}
        value={minPurchase}
        width={'80px'}
        onBlur={(v) => setMinPurchase(v)}
        style={{ marginRight: '10px' }}
      />

      <Select
        label={'Магазин'}
        select={market}
        list={list}
        onSelect={(v) => setMarket(v)}
        width={'120px'}
        style={{ marginRight: '10px' }}
      />
      <Select
        label={'Объединить'}
        select={join}
        valueFn={(v) => v.text}
        list={[
          { text: 'Нет', value: false },
          { text: 'Да', value: true },
        ]}
        onSelect={(v) => setJoin(v)}
        width={'120px'}
        style={{ marginRight: '10px' }}
      />

      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ marginLeft: '15px' }}
        onClick={() => onClick(minPurchase, market, join.value)}
      >
        <Icon src={wb} width={'25px'} style={{ marginRight: '10px' }} />
        Перенести в вб
      </Button>
    </Row>
  );
};
export default WbContentButton;
